import { Box, Flex, IconButton, Spacer } from '@chakra-ui/react';

import { ArrowLeftIcon } from 'lucide-react';
import { useNavigate } from 'react-router';
import { ScrollTabs } from '~/common/components/ScrollTabs/ScrollTabs';
import { useProdFeatureFlagEnabled } from '~/common/hooks/useProdFeatureFlagEnabled';
import { PreparedBy } from '../../../BuyerOfferAnalysis/PreparedBy';
import { useListingPageContext } from '../ListingPageContext';
import {
  DownloadPdfButton,
  OfferScorecardButton,
  ShareWithClientButton,
} from './ActionButtons';
import { SECTIONS } from './constants';

export const ListingPageHeader = () => {
  const navigate = useNavigate();
  const { isViewOnly, reportError, sharedBy } = useListingPageContext();
  const isDownloadPdfEnabled = useProdFeatureFlagEnabled(
    'listing-report-pdf-generation'
  );

  const handleGoBack = () => navigate('/map');

  return (
    <Flex
      alignItems="center"
      bg="indigo.800"
      gap={2}
      justifyContent={isViewOnly ? 'center' : 'space-between'}
      pb={4}
      position="sticky"
      pt={4}
      px={{ base: 4, md: 10 }}
      top={0}
      width="100%"
      zIndex={4}
    >
      {!isViewOnly ? (
        <IconButton
          _hover={{ bg: 'whiteAlpha.300' }}
          aria-label="Go back"
          bg="whiteAlpha.200"
          borderRadius="full"
          color="white"
          h={10}
          icon={<ArrowLeftIcon size={20} />}
          size="sm"
          w={10}
          onClick={handleGoBack}
        />
      ) : (
        <>
          <Box width="200px" />
          <Spacer />
        </>
      )}
      {!reportError && (
        <>
          <ScrollTabs sections={SECTIONS} />
          <Flex alignItems="center" gap={2}>
            {isDownloadPdfEnabled && <DownloadPdfButton iconOnly={false} />}
            <ShareWithClientButton iconOnly={false} />
            <OfferScorecardButton />
          </Flex>
          {isViewOnly && (
            <>
              <Spacer />
              <PreparedBy agent={sharedBy} />
            </>
          )}
        </>
      )}
    </Flex>
  );
};
